export default "__VITE_ASSET__B9tFk56Q__"